import React, { useEffect, useState } from 'react'
import { Box, Button, Divider, FormControl, InputLabel, TextField, Typography } from '@mui/material'
import logo from '../../assets/Project_Images/App_logo.png'
import lock from '../../assets/Project_Images/Icons/Password.png'
import eye from '../../assets/Project_Images/Icons/eye.png'
import { Opacity, PersonOutline } from '@mui/icons-material'
import { Link, useNavigate } from 'react-router-dom'
import { ErrorMessage, useFormik } from 'formik'
import * as Yup from "yup"
import { ApiUsersLogin, getVisitTimes } from '../../apiService/Core/Apicall.tsx'
import { useDispatch, useSelector } from 'react-redux'
import Loading from '../Loader/Loading.tsx'
import { toast, ToastContainer } from 'react-toastify'



interface FormValues {
    username: string;
    password: string;
}

const LoginScreen: React.FC = () => {
    // const [error, setError] = useState(false);
    const [showerror, setshowerror] = useState<boolean>(false);
    const [showportalName, setShowPortalName] = useState<React.ReactNode>(null);


    // const dispatch = useDispatch()
    const navigate = useNavigate()
    const loading = useSelector((state: any) => state.loader.isLoading);
    const initialValues: FormValues = {
        username: '',
        password: '',
    }

    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };

    const onSubmit = async (values: FormValues) => {
        setShowPortalName("")
        localStorage.clear()
        const Apidata = {
            emailId: values.username?.trim(),
            password: values.password?.trim(),
        }
        try {
            const response: any = await ApiUsersLogin(Apidata);
            if (response?.requiresTwoFactor) {
               if (response?.roleName === "shopper") {
                    navigate("/verify", {
                        state: {
                            username: values.username?.trim(),
                            password: values.password?.trim(),
                            tempToken: response?.tempToken
                        }
                    });
                } else  if (response?.roleName === "admin" || response?.roleName === "superadmin" || response?.roleName === "editor"){
                    toast.error("Invalid Access");
                    setShowPortalName(
                        <div>
                            Please Login to{" "}
                            <a
                                href={process.env.REACT_APP_ADMIN_SITE}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Admin Portal
                            </a>
                        </div>
                    );
                } else if (response?.roleName === "clientadmin" || response?.roleName === "areaManager" || response?.roleName === "venueadmin") {
                    toast.error("Invalid Access");
                    setShowPortalName(
                        <div>
                            Please Login to{" "}
                            <a
                                href={process.env.REACT_APP_MM_CLIENT_SITE}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Client Portal
                            </a>
                        </div>
                    );
                }
                else{
                    toast.error("Invalid Access")
                }
            }
            else if (response.status && response.userDetails.role.roleName === 'shopper') {
                // console.log(response)
                const userData = {
                    'userId': response.userDetails.userId,
                    'shopperAgreementFileUrl': response.userDetails.shopperAgreementFileUrl,
                    'isCompletedForm1': response.userDetails.isShopperStep1DocumentSubmitted,
                    'isCompletedAllForm': response.userDetails.isShopperAllDocumentSubmitted,
                    'userStatus': response.userDetails.userStatus.userStatus,
                    'isLatestAgreementSigned': response.userDetails.isLatestAgreementSigned,
                    'isMigratedShopper': response?.otherDetails?.isMigratedShopper,
                    'isMigratedShopperUpdateDetails': response?.otherDetails?.isMigratedShopperUpdateDetails,

                }
                localStorage.setItem('userData', JSON.stringify(response.userDetails));
                localStorage.setItem('userOthreData', JSON.stringify(response.otherDetails));
                localStorage.setItem('token', response?.token || 0);
                localStorage.setItem('isTransport', response.otherDetails?.isShopperCanWorkForTransport);
                localStorage.setItem('ActiveTask', 'dashboard');

                if (userData.userStatus === 'delete') {
                    toast.error("Account not found")
                    localStorage.clear()
                    navigate('/login')
                }
                else if (response.userDetails.isAirTasker) {
                    navigate('/dashboard/dashboard')
                }
                else if (userData.isCompletedForm1 && (userData.isLatestAgreementSigned === false)) {
                    localStorage.setItem('i-x-s', response.otherDetails.isMigratedShopper);
                    localStorage.setItem('i-x-s-u', response.otherDetails.isMigratedShopperUpdateDetails);
                    navigate('/agreement')
                }
                else if (userData?.isMigratedShopper && userData.isMigratedShopperUpdateDetails === false) {
                    localStorage.setItem('i-x-s', response.otherDetails.isMigratedShopper);
                    localStorage.setItem('i-x-s-u', response.otherDetails.isMigratedShopperUpdateDetails);
                    navigate('/dashboard/myprofile')
                }
                else if (userData.isCompletedForm1) {
                    // if()
                    if (userData.isCompletedAllForm && userData.userStatus === 'active') {
                        navigate('/dashboard/dashboard')
                        // navigate('/terms')
                    }
                    else if (userData.userStatus === 'approve') {
                        navigate('/applicationform2')
                    }
                    else {
                        navigate('/applicationform')
                    }
                }
                else {
                    navigate('/applicationform')
                }
            }
            else {
                toast.error('Invalid Access')
            }
        }
        catch (error) {
            const message =
                error?.response?.data?.message || // API error message
                error?.message ||                 // JS error message
                String(error);
            // toast.error(message)
            alert(message)

        }



    }
    const validationSchema = Yup.object({
        username: Yup.string().required("Username is required"),
        password: Yup.string()
            .min(8, "Password must be at least 8 characters long")
            .required("Password is required"),
    });
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: true,
    })
    const [showpassword, setshowpassword] = useState<boolean>(false)
    return (
        <>
            <Box className='p-50-120 d-flex flex-column' height={{ xs: "81vh", sm: '100vh' }}>
                <Box component='img' className='col-md-4 col-6 mb-md-4 mb-5' src={logo} alt="" />
                <Box className='flex-grow-1' position='relative'>
                    <Typography className='text-main fs-3 fw-bold'>Welcome Back</Typography>
                    <Typography className='fs-18 '>Get started using your email.</Typography>
                    <Box className='mt-5  mt-md-0 mb-0 pb-0'>
                        <form onSubmit={formik.handleSubmit}>
                            <FormControl className='col-12'>
                                <TextField
                                    onKeyUp={keyup}
                                    placeholder='User Name'

                                    label={
                                        <span>
                                            Email ID{" "}
                                            <sup>
                                                <i className="fa-solid fa-star-of-life star"></i>
                                            </sup>
                                        </span>
                                    }
                                    slotProps={{
                                        input: {
                                            startAdornment: <PersonOutline className='fs-2 text-main' sx={{ fill: '#ADB792 !important' }} />
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: false,
                                    }}
                                    InputProps={{
                                        sx: { "&::placeholder": { opacity: 1, visibility: 'visible', display: "block" } }, // Ensures placeholder is visible
                                    }}

                                    {...formik.getFieldProps("username")}
                                ></TextField>
                                {showerror && formik.errors.username ? (
                                    <Typography className="error ">
                                        {formik.errors.username}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <FormControl className='col-12'>
                                <TextField
                                    onKeyUp={keyup}
                                    type={showpassword ? 'text' : 'password'}
                                    placeholder='Password'
                                    label={
                                        <span>
                                            Password{" "}
                                            <sup>
                                                <i
                                                    className="fa-solid fa-star-of-life"
                                                    style={{ color: "#fa0000", fontSize: "0.5rem" }}
                                                ></i>
                                            </sup>
                                        </span>
                                    }

                                    slotProps={{
                                        input: {
                                            startAdornment: <Box component='img' src={lock} height='24px' width='24px' />,
                                            endAdornment: <Button onClick={() => { setshowpassword(!showpassword) }}><Box component='img' src={eye} height='24px' width='24px' /></Button>
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: false,

                                    }}
                                    {...formik.getFieldProps("password")}
                                ></TextField>
                                {showerror && formik.errors.password ? (
                                    <Typography className="error ">
                                        {formik.errors.password}
                                    </Typography>
                                ) : null}
                            </FormControl>
                            <Link to='/createShopper' state={{ isForgot: true }} className='custom-text text-end d-block my-2'>Forgotten your password?</Link>
                            <Box className='my-2'>{showportalName}</Box>
                            <Button type='submit' onClick={() => setshowerror(true)} fullWidth className='button-primary mt-5'>Login</Button>
                            {/* <Divider className='my-3'  sx={{borderColor:'#a3a3a3', display:{xs:'block', lg:'none'}}}>or</Divider> */}
                        </form>
                        <Box className='w-100 mt-5'><Link to='/createShopper'><Button fullWidth variant='outlined' className='button-secondary-outlined'>Become a Shopper</Button></Link></Box>
                        <Box className='d-flex justify-content-center mt-5 mb-2'><Link to='/terms' className='text-center mt-2  custom-text'>Terms & Conditions</Link></Box>
                    </Box>
                </Box>
                {loading && <Loading />}
            </Box>
        </>

    )
}

export default LoginScreen
